import React from "react";
import { compose, withState, withProps, withHandlers } from "recompose";
import styled from "styled-components";
import Switch from "react-switch";
import Modal from "../common/Modal";
import { PrimaryButton } from "../common/Button";

const withTogglesState = compose(
  withState("togglesState", "setTogglesState", props => props.storySettings),
  withHandlers({
    handleToggleChange: ({ togglesState, setTogglesState }) => ({ setting, newValue }) => {
      const newTogglesState = {};
      newTogglesState[setting] = newValue;
      setTogglesState({ ...togglesState, ...newTogglesState });
    },
  })
);

const CustomizeGrid = ({ togglesState, handleToggleChange, setStorySettings }) => (
  <Container>
    <Title>Customize</Title>
    <SettingsSwitch
      text="Total likes count"
      checked={!togglesState.hideTotalLikes}
      onChange={value => handleToggleChange({ setting: "hideTotalLikes", newValue: !value })}
    />
    <SettingsSwitch
      text="Likes per post"
      checked={!togglesState.hidePostLikes}
      onChange={value => handleToggleChange({ setting: "hidePostLikes", newValue: !value })}
    />
    <SettingsSwitch
      text="Stats"
      checked={!togglesState.hideStats}
      onChange={value => handleToggleChange({ setting: "hideStats", newValue: !value })}
    />
    <SettingsSwitch
      text={"SummaryCaption"}
      description={'"Life is all about experiences..."'}
      checked={!togglesState.hideSummaryCaption}
      onChange={value => handleToggleChange({ setting: "hideSummaryCaption", newValue: !value })}
    />
    <Cta onClick={() => setStorySettings(togglesState)}>Done</Cta>
    <SettingDescription style={{ textAlign: "center", margin: "10px 0px" }}>
      {"Changes will be applied once you export your Top Nine"}
    </SettingDescription>
  </Container>
);

const Title = styled.div`
  color: black;
  margin: 15px 0px 30px;
  text-align: center;
  font-weight: 600;
  line-height: 28px;
  font-size: 22px;
  font-family: "Montserrat";
  letter-spacing: -0.24;
`;

const Cta = styled(PrimaryButton)`
  width: 60%;
  margin: 32px 0px 0px;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 320px;
  padding: 25px;
  margin: auto;
  max-width: 640px;
`;

const SettingsSwitch = ({ text, description, checked, onChange }) => (
  <SettingContainer>
    <SettingTextLayout>
      <SettingText>{text}</SettingText>
      {description && <SettingDescription>{description}</SettingDescription>}
    </SettingTextLayout>
    <CustomSwitch checked={checked} onChange={onChange} />
  </SettingContainer>
);

const CustomSwitch = props => (
  <Switch
    onColor="#86d3ff"
    onHandleColor="#2693e6"
    handleDiameter={25}
    uncheckedIcon={false}
    checkedIcon={false}
    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
    height={20}
    width={45}
    {...props}
  />
);

const SettingTextLayout = styled.div`
  display: flex;
  flex-direction: column;
`;

const SettingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 70px;
`;

const SettingText = styled.div`
  font-weight: "500";
  line-height: 16px;
  font-size: 14px;
  font-family: "Montserrat";
  letter-spacing: 0.24;
`;

const SettingDescription = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  font-weight: normal;
  font-family: "Montserrat";
  margin-right: 10px;
  margin-top: 8px;
`;

const CustomModal = styled(Modal)`
  background-color: #ffffff;
  @media (max-width: 640px) {
    height: 100%;
    width: 100%;
  }
`;

const CustomizeGridModal = props => (
  <CustomModal {...props}>
    <CustomizeGrid {...props} />
  </CustomModal>
);

export default withTogglesState(CustomizeGridModal);
